import React from "react";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { 
  FaReact, 
  FaNodeJs, 
  FaDocker, 
  FaAws 
} from "react-icons/fa";
import { 
  SiFlutter, 
  SiExpress, 
  SiFirebase, 
  SiMongodb, 
  SiPostgresql, 
  SiSap 
} from "react-icons/si";

const Technologies = () => {
  const { t } = useTranslation();

  const techs = [
    { name: "Flutter", icon: SiFlutter, color: "hover:text-blue-400 hover:border-blue-400/40" },
    { name: "React / Next.js", icon: FaReact, color: "hover:text-sky-400 hover:border-sky-400/40" },
    { name: "Node.js", icon: FaNodeJs, color: "hover:text-emerald-500 hover:border-emerald-500/40" },
    { name: "Express", icon: SiExpress, color: "hover:text-neutral-600 dark:hover:text-neutral-400 hover:border-neutral-500/40" },
    { name: "Firebase", icon: SiFirebase, color: "hover:text-amber-500 hover:border-amber-500/40" },
    { name: "MongoDB", icon: SiMongodb, color: "hover:text-green-500 hover:border-green-500/40" },
    { name: "PostgreSQL", icon: SiPostgresql, color: "hover:text-sky-600 hover:border-sky-600/40" },
    { name: "Docker", icon: FaDocker, color: "hover:text-blue-500 hover:border-blue-500/40" },
    { name: "AWS", icon: FaAws, color: "hover:text-orange-400 hover:border-orange-400/40" },
    { name: "SAP Systems", icon: SiSap, color: "hover:text-blue-700 dark:hover:text-blue-400 hover:border-blue-600/40" },
  ];

  return (
    <section className="py-20 md:py-28 bg-slate-50 dark:bg-[#0c0c0e] transition-colors duration-500 overflow-hidden relative">
      {/* Background gradients */}
      <div className="absolute top-1/4 left-1/4 w-80 h-80 rounded-full bg-blue-500/5 dark:bg-purple-500/5 blur-3xl" />

      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="text-center mb-16">
          <span className="text-xs font-bold text-blue-600 dark:text-purple-400 uppercase tracking-widest">
            {t('techLabel', 'Infrastructure')}
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-slate-900 dark:text-white mt-2 tracking-tight">
            {t('techTitle', 'Technologies We Excel In')}
          </h2>
          <div className="w-20 h-1 bg-gradient-to-r from-blue-600 to-indigo-600 dark:from-purple-500 dark:to-pink-500 mx-auto mt-4 rounded-full" />
        </div>

        <div className="flex flex-wrap items-center justify-center gap-4 sm:gap-6 max-w-4xl mx-auto">
          {techs.map((tech, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, scale: 0.8 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.05, type: "spring", stiffness: 100 }}
              whileHover={{ 
                scale: 1.05,
                y: -4,
                transition: { duration: 0.2 }
              }}
              className={`flex items-center gap-3 px-5 py-3 rounded-2xl bg-slate-50 dark:bg-[#111111] border border-slate-200/50 dark:border-neutral-800/60 shadow-sm hover:shadow-md transition-all duration-300 cursor-pointer ${tech.color}`}
            >
              <tech.icon className="w-6 h-6 transition-transform duration-300 group-hover:scale-110" />
              <span className="text-sm font-bold text-slate-800 dark:text-slate-200">{tech.name}</span>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Technologies;
